// extracted by mini-css-extract-plugin
module.exports = {"user-link":"UserLink_user-link__rBq8g","user-suffix":"UserLink_user-suffix__KvtsQ"};